 <!-- Form Card -->
  <div class="bg-white mt-6 lg:mt-10 w-full rounded-xl shadow-sm">
    <div class="p-4 md:py-8 md:px-10 xl:py-10 xl:px-20 rounded-xl bg-white ">
      <form>
        <p class="text-[#444] font-bold text-base md:text-xl xl:text-2xl mb-4 lg:mb-8">New Credentials</p>

        <p class="text-sm lg:text-base xl:text-lg text-[#898989] mb-6">Enter your details to update your artistic account password.</p>

        <!-- Email ID Input -->
        <div class="relative mb-6 lg:mb-8">
          <input readonly type="email" id="emailId" name="email" [(ngModel)]="email"
            class="block px-2.5 pb-3 bg-gray-200 pt-3 w-full text-sm lg:text-base xl:text-base text-[#444] font-normal rounded-lg border border-[#dcdcdc] appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
            placeholder=" " />
          <label for="emailId"
            class="absolute text-sm lg:text-base xl:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-[#c19725] peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 pointer-events-none">Email ID</label>
        </div>

        <!-- New Password Input -->
        <div class="relative mb-6 lg:mb-8">
          <input type="password" id="newPassword" name="password" [(ngModel)]="password"
            class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base xl:text-base text-[#444] font-normal bg-transparent rounded-lg border border-[#dcdcdc] appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
            placeholder=" " />
          <label for="newPassword"
            class="absolute text-sm lg:text-base xl:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-[#c19725] peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 pointer-events-none">New Password</label>
        </div>

        <!-- Confirm Password Input -->
        <div class="relative mb-6 lg:mb-8">
          <input type="password" id="confirmPassword" name="master_password" [(ngModel)]="master_password"
            class="block px-2.5 pb-3 pt-3 w-full text-sm lg:text-base xl:text-base text-[#444] font-normal bg-transparent rounded-lg border border-[#dcdcdc] appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
            placeholder=" " />
          <label for="confirmPassword"
            class="absolute text-sm lg:text-base xl:text-base text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-[#c19725] peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 pointer-events-none">Confirm Password</label>
        </div>

        <!-- Centered Submit Button -->
        <div class="flex items-center justify-center mt-8 md:mt-12 lg:mt-16">
          <button type="button" (click)="updatePassword()"
            class="block cursor-pointer px-5 md:px-7 lg:px-10 w-[180px] lg:w-[320px] py-2 lg:py-3.5 text-base md:text-lg lg:text-2xl font-bold text-white bg-[#c19725] border-2 border-[#c19725] hover:bg-[#fdffc6] hover:text-[#c19725] hover:shadow-lg focus:ring-0 focus:outline-none rounded-lg text-center transition-all duration-200">
            Update Password
          </button>
        </div>

        <!-- Back Link -->
        <p class="font-normal text-sm lg:text-lg text-center mt-6 text-[#c19725]">
          <a href="#" class="hover:underline">Back to Sign In</a>
        </p>
      </form>
    </div>
  </div>
